import { Outlet } from "react-router-dom";

import { FilterBillingProvider } from "./filter-billing/filter-billing.context";
import './billing.scss';

export function Billing() {
  return (
    <div id="ShellBilling" className="billing">
       <FilterBillingProvider>
        <Outlet />
      </FilterBillingProvider>
    </div>
  );
}

export default Billing;
